import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'of-login-failed',
    imports: [],
    template: ` <p>Login failed. Please try again.</p> `
})
export class LoginFailedComponent {}
